module.exports = __webpack_public_path__ + "img/954.b378526b.png";